/**
 *  account/Login.jsx
 *  Security Care
 *
 *  Last update by Bruno Bandeira on 05/03/2019.
 *  Contact: bruno@avamobile.com.br
 *
 *  Copyright © 2018 AVA Soft Solutions. All rights reserved.
 */

// system
import React, { Component } from "react";

// notifications
import NotificationSystem from "react-notification-system";

// redux
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { saveAccount, clearAccount } from "../../actions/account";

// template
import {
  Form,
  FormGroup,
  FormControl,
  ControlLabel,
  Button,
} from "react-bootstrap";
import { style } from "../../variables/Variables.jsx";

// style
//import "./style.css";
//import "./style_SOUL.css";
//import "./style_DCM.css";
import "./style_ADG.css";

// global
var firebase = require("../../firebase");
var utils = require("../../utils/index.js");

class Login extends Component {
  constructor(props) {
    super(props);

    this.state = {
      email: "",
      password: "",
      buttonName: "Entrar",
      _notificationSystem: null,
    };
  }

  componentWillMount() {
    this.isLogged();

    firebase.auth.onAuthStateChanged((user) => {
      if (user) {
        this.getUser(user.uid);
      }
    });
  }

  componentDidMount = () => {
    document.title = "Security Care | Acesse sua conta";
    this.setState({ _notificationSystem: this.refs.notificationSystem });
  };

  getUser = (key) => {
    let user;

    firebase.database.ref(`/users/${key}`).once("value", (snapshot) => {
      user = snapshot.val() || {};
      user["key"] = key;

      if (user.status === 1) {
        this.setState({ buttonName: "Entrar" }, () => {
          this.isAdmin(user);
        });
      } else {
        this.setState({ buttonName: "Entrar" }, () => {
          this.notify("Oops! Sua conta está temporariamente desativada.");
        });
      }
    });
  };

  isAdmin = (user) => {
    const { history, saveAccount } = this.props;

    this.setState({ buttonName: "Entrar" }, () => {
      saveAccount(user);
      history.push("/home");
    });
  };

  isLogged = () => {
    if (firebase.auth.currentUser) {
      this.auth(firebase.auth.currentUser.uid);
    }
  };

  onSubmitLogin = (e) => {
    e.preventDefault();

    const email = this.state.email;
    const password = this.state.password;

    this.setState({ buttonName: "Aguarde..." });

    firebase.auth.signInWithEmailAndPassword(email, password).catch((error) => {
      this.setState({ buttonName: "Entrar" }, () => {
        this.notify(utils.portugueseMessage(error.message));
      });
    });
  };

  onFieldChanged = (e) => {
    this.state[e.target.name] = e.target.value;
  };

  notify = (error) => {
    const level = "error";

    this.state._notificationSystem.addNotification({
      title: <span data-notify="icon" className="pe-7s-bell" />,
      message: <div>{error}</div>,
      level: level,
      position: "tr",
      autoDismiss: 15,
    });
  };

  render() {
    return (
      <div className="container-bg">
        <NotificationSystem ref="notificationSystem" style={style} />
        <div className="bg-card">
          <div className="text-center">
            <img
              src={require("../../assets/img/logo_pc__web.png")}
              className="logo-login"
            ></img>
            {/* <i className="pe-7s-lock"></i> ADMIN */}

            <h5 className="text-dark sub-logo">
              Informe os dados abaixo para ter acesso.
            </h5>
          </div>
          <Form
            horizontal
            onChange={this.onFieldChanged}
            onSubmit={this.onSubmitLogin}
          >
            <FormGroup controlId="formEmail">
              <ControlLabel>{"Email:"}</ControlLabel>
              <FormControl name="email" type="email" placeholder="Email" />
            </FormGroup>

            <FormGroup controlId="formPassword">
              <ControlLabel>{"Senha:"}</ControlLabel>
              <FormControl
                name="password"
                type="password"
                placeholder="Senha"
              />
            </FormGroup>

            <FormGroup>
              <Button type="submit" className="btn btn-primary btn-b">
                {this.state.buttonName}
              </Button>
            </FormGroup>
          </Form>
          <p className="version-text text-center">Versão 1.0.7</p>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (store) => ({
  account: store.account.account,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators({ saveAccount, clearAccount }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(Login);



// WEBPACK FOOTER //
// ./src/layouts/Account/Login.jsx